import { render, staticRenderFns } from "./assessment-header-card.component.vue?vue&type=template&id=e98965c6&scoped=true&"
import script from "./assessment-header-card.component.vue?vue&type=script&lang=ts&"
export * from "./assessment-header-card.component.vue?vue&type=script&lang=ts&"
import style0 from "./assessment-header-card.component.vue?vue&type=style&index=0&id=e98965c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98965c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
